import { Flex, Box } from "@chakra-ui/react";

const PageLoader = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      w="100vw"
      h="100vh"
      bg="rgba(255, 255, 255, 0.88)"
      backdropFilter="blur(3px)"
      align="center"
      justify="center"
      zIndex="9999"
    >
      <Box className="page-loader-ring" />
    </Flex>
  );
};

export default PageLoader;
